/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tiny-arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 8 5',
    data: '<path pid="0" d="M3.549 4.8a.61.61 0 00.902 0L7.872.864C8.175.516 7.906 0 7.421 0H.579C.094 0-.175.516.128.864L3.548 4.8z" _fill="#000"/>'
  }
})
